import React, { Component } from 'react';
import { connect } from 'react-redux';

import Box from 'grommet/components/Box';
import Heading from 'grommet/components/Heading';
import Paragraph from 'grommet/components/Paragraph';
import List from 'grommet/components/List';
import ListItem from 'grommet/components/ListItem';
import { said, appUrl } from '../../AppConfig';
import CloseIcon from 'grommet/components/icons/base/Close';
//import latestWhatsNew from '../../Datafiles/latestWhatsNew';
//import latestWhatsNew from '../../Datafiles/WhatsNewEPA';


class WhatsNewComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            WhatsnewJson: '',

        };
        this.closePopUps = this.closePopUps.bind(this);
    }
    closePopUps(e) {
        this.props.click();
    }

    getReleaseItems  = (items) =>{
        let itemarray=[];
        items.map((x) => {
            if (typeof x !== "object") {
                itemarray.push(<ListItem justify='between' separator='none' style={{ padding: '0px' }}>
                   <li> <Paragraph margin='none' pad='none'> {x} </Paragraph></li>
                </ListItem>)
            } else {
                let heading = x["@heading"]
                let objectArray = []
                if(Array.isArray(x.SubItem)){
                x.SubItem.map((subvalue) => {
                    objectArray.push(<ListItem justify='between' separator='none' style={{ padding: '0px', marginLeft:'20px' }}>
                        <Paragraph style={{maxWidth:'100%'}} margin='none' pad='none'> {subvalue} </Paragraph>
                    </ListItem>)
                })
                }else{
                     objectArray=<ListItem justify='between' separator='none' style={{ padding: '0px', marginLeft:'20px' }}>
                        <Paragraph  margin='none' pad='none'> {x.SubItem} </Paragraph>
                    </ListItem>
                }
                console.log(objectArray)
                itemarray.push(<Box justify='between' separator='none' style={{ padding: '0px' }}>
                    <li style={{ marginLeft: '0px', marginBottom: '0px' }}>
                         <Heading tag="h5" strong={false} style={{ margin: '4px 0px' }}> {heading}</Heading></li>
                    {objectArray}
                </Box>)

            }
        })
        return itemarray;
    }

    render() {

        let content = '';
        //let itemarray = [];
        let whatsNewHeight = ''
        if (said !== 'SAPHANA') {
            whatsNewHeight = '500px'
        }
        let allItems=[];
        let whatsNewObject = this.props.WhatsNewContent;
        if (appUrl.toUpperCase().indexOf('EZMERALCPSIZER') !== -1) {
            whatsNewObject = this.props.WhatsNewContentHPECP;
        }        
        if( whatsNewObject !== undefined && whatsNewObject !== '' ){
        this.state.WhatsnewJson = whatsNewObject;
        if(Array.isArray(this.state.WhatsnewJson.Screen.ItemList))
        {
            allItems = this.state.WhatsnewJson.Screen.ItemList ;
        } 
        else{
            allItems.push(this.state.WhatsnewJson.Screen.ItemList);
        }
        content = <Box margin="none" pad="none" direction="column" className="WhatsNewContent" style={{ width: '45%', height: 'auto' }}>
            <Box margin="none" pad="none" style={{ backgroundColor: '#fff', borderBottom: '3px solid #01a982', height: whatsNewHeight }} className="ListItemAlign1">
                <Box direction="row" margin="none" pad="small" separator="bottom" style={{ backgroundColor: 'rgb(66, 85, 99)', color: 'white' }}>
                    <Box direction="row" margin="none" pad="none" align='start' style={{ width: '96%' }}>
                        <Heading tag="h4" strong={false} style={{ marginBottom: '0px' }}>{this.props.DefaultInputs.SizerCaption}</Heading>
                    </Box>
                    <Box direction="row" margin="none" pad="none" align='start' alignContent="start" onClick={this.closePopUps} >
                        <CloseIcon className="CloseIconStyle" size='small' style={{ stroke: '#fff' }} />
                    </Box>
                </Box>
                <Box style={{ overflowY : 'auto' }}>
                <Box pad="none" align='start' style={{ margin: '2px 12px' }}>
                    <Paragraph margin='none' pad='none'>  <Heading tag="h5" strong={false} style={{ marginBottom: '0px' }}>{this.state.WhatsnewJson.Screen.Intro}</Heading> </Paragraph>
                </Box>
                <Box style={{margin:'12px'}}>
                {                
                allItems.map((releaseItem)=>{
                    return <Box margin="none" pad="none" align='start' >
                    <Paragraph margin='none' pad='none' style={{ fontWeight: '510' }}>     {releaseItem['@heading']}</Paragraph>
                    <List style={{ overflow: 'initial' }}>
                        {/*<ListItem justify='between' separator='none' style={{padding: '0px'}}>
                                                 <Paragraph margin='none' pad='none'> {itemarray} </Paragraph> 
                                      </ListItem> */}
                        <ul style={{marginLeft:'20px', padding:'0px'}}>
                        {this.getReleaseItems(releaseItem.Item)}
                        </ul>
                    </List>                   
                </Box>
                })
                }
                </Box>
                </Box>
                 {/*<Paragraph style={{margin:'2px 12px'}}>Last Modified:30/05/2019</Paragraph>*/}
            </Box>
        </Box>

        // }else{
        //     content = '';
         }
        return (
            <Box margin="none" pad="none">{content}   </Box>
        );

    }
}

const mapStateToProps = (state) => {
    return {
        activeSession: state.sessions.activeSession,
        DefaultInputs: state.sessions.sessionDefaults.inputs.Sizers,
        WhatsNewContent: state.sessions.sessionDefaults.whatsNew,
        WhatsNewContentHPECP: state.sessions.sessionDefaults.whatsNewHPECP,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WhatsNewComponent);



// WEBPACK FOOTER //
// ./src/SizingEngineUI/SizingEngineCommonScreens/WhatsNew.js